





























































































































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import ScenePreview from "@/components/ScenePreview.vue";
import ConfigurationMenu from "@/components/ConfigurationMenu.vue";
import ConfigurationSideMenu from "@/components/ConfigurationSideMenu.vue";
import ComponentsList from "@/components/ComponentsList.vue";
import SlotsPreview from "@/components/SlotsPreview.vue";
import { ItemSection, IItemSection } from "@/models/itemSection";
import { ItemParams } from "@/models/itemParams";
import Cell from "@/models/cell";
import { ISectionCreator, sectionCreator } from "@/models/sectionCreator";
import { Scene, Engine } from "@babylonjs/core";
import { SceneConfiguration } from "@/models/sceneConfiguration.ts";
import { messager } from "@/models/messager";
import Element from "@/models/element";
import {
  ElementPresetData,
  ShadersPresetData,
  PresetData,
} from "@/models/presets.ts";
import { stringUtil } from "@/models/stringUtil.ts";
import { ScreenMaker } from "@/models/screenMaker";
import SvgIcon from "@/components/SvgIcon.vue";
import LoadingProductError from "@/components/LoadingProductError.vue";
import { PresetCreator } from "@/models/presetCreator.ts";
import { CallbackManager } from "@/models/callbackManager.ts";
import ProductDialog from "@/components/ProductDialog.vue";
import { correctnessManager } from "@/models/correctness/correctnessManager.ts";
import { ElementType, SpecyficType } from "@/models/element";
import { Product, ProductType } from "@/store/modules/product";

@Component({
  components: {
    ScenePreview,
    ConfigurationMenu,
    ConfigurationSideMenu,
    ComponentsList,
    SlotsPreview,
    SvgIcon,
    LoadingProductError,
    ProductDialog,
  },
})
export default class ConfigurationScene extends Vue {
  @Prop({ type: Boolean, default: true }) visibility!: Boolean;

  componentsListVisibility = false;

  sections: IItemSection[] = [];
  sectionCreator: ISectionCreator = sectionCreator;

  scene: Scene | null = null;
  engine: Engine | null = null;
  sceneConfiguration: SceneConfiguration | null = null;
  private unit: string = "cm";
  private savedproject = "";
  private debugName: string = "";
  private debugPrefix: string = "";
  private debugComplex: boolean = false;
  private debugEmpty: boolean = false;
  private dialog: boolean = false;
  private debugSaveProject: boolean = false;
  private presetCreator: PresetCreator = new PresetCreator();
  private productDialog: boolean = false;
  private productData: string = null;
  private productGraphics: any = null;
  private productCorrect: boolean = false;
  private useAllImages: boolean = false;

  private get price(): string {
    const quantity = this.$store.getters.sap.quantity;
    const p: number =
      quantity * this.$store.getters.sap.calculation.value.price.currentPrice;
    return p % 1 === 0 ? p.toFixed(0) : p.toFixed(2);
  }

  private get productPrice(): string {
    return `${this.price} ${this.$store.getters.sap.calculation.value.price.currencySymbol}`;
  }

  created() {
    this.sectionCreator.onSectionsChanged.on((sections) => {
      this.sections = sections;
    });

    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "configurationChange") {
        this.onConfigurationChange();
      }
    });
  }

  private get cantCallCallback(): boolean {
    return (
      this.$store.getters.sap.calculation.loading ||
      this.$store.getters.scene.tasks > 0
    );
  }

  private get width(): string {
    const width = `${(this.$store.getters.productFullWidth / 10).toFixed(1)}`;
    return width.replace(".", ",");
  }

  private get depth(): string {
    const width = `${(this.$store.getters.productFullDepth / 10).toFixed(1)}`;
    return width.replace(".", ",");
  }

  private get height(): string {
    const width = `${(this.$store.getters.productFullHeight / 10).toFixed(1)}`;
    return width.replace(".", ",");
  }

  private get resetModelIcon() {
    return "tools/new.svg";
  }

  private get saveProjectIcon() {
    return "tools/save.svg";
  }

  private get addToVoxBoxIcon() {
    return "tools/voxbox.svg";
  }

  private get addToCartIcon() {
    return "tools/buy.svg";
  }

  private get shareProjectIcon() {
    return "tools/social.svg";
  }

  private openComponentsList(cells: Cell[]) {
    // console.log(cells);
  }

  private engineCreated(
    engine: Engine,
    scene: Scene,
    sceneConfiguration: SceneConfiguration
  ) {
    this.engine = engine;
    this.scene = scene;
    this.sceneConfiguration = sceneConfiguration;
  }

  /**
   * Zapis presetu do katalogu z zasobami. Teoretycznie używana tylko w wersji developerskiej.
   */
  private savePreset() {
    const manager = new CallbackManager(
      this.scene,
      this.engine,
      this.sceneConfiguration
    );
    const callback = manager.create();
    const presetData = callback.data;
    presetData.productPreset.id = null;
    presetData.productPreset.code = null;
    presetData.productPreset.name = null;
    presetData.productPreset.codeErp = null;

    if (
      this.scene != null &&
      this.engine != null &&
      this.sceneConfiguration != null
    ) {
      var screenMaker = new ScreenMaker((x) => {
        if (x) {
          var json = JSON.stringify(presetData);
          var base64 = x;
          var name = this.debugName;
          var complex = this.debugComplex;
          var id = this.$store.getters.configuration.productId;
          var prefix = this.debugPrefix;
          var empty = this.debugEmpty;

          this.$api
            .uploadPreset(id, json, base64, name, complex, prefix, empty)
            .then((p) => {
              this.dialog = false;

              const message = this.$t("projectSaved").toString();
              messager.info(message);
            });
        }
      });

      const screenSize = (() => {
        const product: Product = this.$store.getters.product;
        if (product.type === ProductType.BED) {
          return {
            height: 800,
            width: 1200,
          };
        }
        return 800;
      })();

      screenMaker.preparePanel(
        this.scene,
        this.engine,
        this.sceneConfiguration,
        screenSize,
        true
      );
    }
  }

  private saveProject() {
    if (this.debugSaveProject) {
      this.dialog = true;
    } else {
      if (this.$store.getters.configuration.events.onSaveProject) {
        const manager = new CallbackManager(
          this.scene,
          this.engine,
          this.sceneConfiguration
        );
        const callback = manager.create();
        this.$store.getters.configuration.events.onSaveProject(
          callback.data,
          callback.graphics
        );
      } else {
        const message = this.$t("projectSaved").toString();
        messager.info(message);
      }
    }
  }

  private shareProject() {
    if (this.$store.getters.configuration.events.onShareProject) {
      const manager = new CallbackManager(
        this.scene,
        this.engine,
        this.sceneConfiguration
      );
      const callback = manager.create();
      this.$store.getters.configuration.events.onShareProject(
        callback.data,
        callback.graphics
      );
    }
  }

  private onConfigurationChange() {
    const manager = new CallbackManager(
      this.scene,
      this.engine,
      this.sceneConfiguration
    );
    const callback = manager.create();
    this.$store.getters.configuration.events.onConfigurationChange(
      callback.data,
      callback.extraData
    );
  }

  private addToVoxBox() {
    // const message = this.$t("addedToVoxbox").toString();
    // messager.info(message);
    // this.$store.getters.configuration.onAddToVoxBox();
    const manager = new CallbackManager(
      this.scene,
      this.engine,
      this.sceneConfiguration
    );
    const callback = manager.create();
    this.$store.getters.configuration.events.onAddToVoxBox(
      callback.data,
      callback.graphics
    );
  }

  addToCartCallback(data, graphics) {
    this.productDialog = false;
    const quantity = this.$store.getters.sap.quantity;
    this.$store.getters.configuration.events.onAddToCart(
      data,
      graphics,
      quantity
    );
  }

  private isProductCorrect(): boolean {
    return correctnessManager.isProductCorrect;
  }

  private addNecessaryWall(
    then: (x: boolean, y: boolean) => void = () => {}
  ): void {
    const scenePreview = this.$refs["scene-preview"];
    correctnessManager.correctProduct(scenePreview, then);
  }

  private addToCart() {
    if (this.$store.getters.configuration.events.onAddToCart) {
      if (!this.isProductCorrect()) {
        this.addNecessaryWall(this.onAddToCartProductCorrect);
      } else {
        this.onAddToCartProductCorrect(true);
      }
    } else {
      const message = this.$t("addedToCart").toString();
      messager.info(message);
    }
  }

  private hasAnyFronts(data: any): boolean {
    return data.elements.filter((x) => x.type == ElementType.FRONT).length > 0;
  }

  private onAddToCartProductCorrect(correct: boolean, open: boolean = true) {
    if (open) {
      const manager = new CallbackManager(
        this.scene,
        this.engine,
        this.sceneConfiguration
      );
      const callback = manager.create();

      this.productData = callback.data;
      this.productGraphics = callback.graphics;
      this.productCorrect = correct;
      this.useAllImages = this.hasAnyFronts(callback.data);

      this.productDialog = true;
    }
  }
}
